<template>
    <div class="reader">
        <v-container>
            <v-row>
                <v-col>
                    <v-text-field readonly v-model="registrationCode" id="linkField">
                        <template v-slot:prepend>
                            <v-btn @click="getRegistrationCode" color="primary" dense>Generate</v-btn>
                        </template>
                        <template v-slot:append-outer>
                            <v-btn @click="copyLink" color="secondary" dense>Copy Link</v-btn>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-data-table
                        :headers="headers"
                        :items="users"
                        :items-per-page="15"
                        dense
                        class="elevation-1"
                        :footer-props="{
                            showFirstLastPage: true,
                            itemsPerPageOptions: [-1, 10, 15, 20, 25],
                            firstIcon: 'mdi-arrow-collapse-left',
                            lastIcon: 'mdi-arrow-collapse-right',
                            prevIcon: 'mdi-minus',
                            nextIcon: 'mdi-plus',
                        }"
                    >
                        <template v-slot:[`item.firstName`]="{ item }">
                            <router-link
                                :to="{ name: 'editUser', params: { id: item.id } }"
                                :title="`Edit ${item.firstName} ${item.lastName}`"
                            >
                                {{ item.firstName }} {{ item.lastName }}
                            </router-link>
                        </template>
                        <template v-slot:[`item.lastLogin`]="{ item }">
                            {{ item.lastLogin | luxonSortableDateTime }}
                        </template>
                        <template v-slot:[`item.roles`]="{ item }">
                            {{ item.roles.join() }}
                        </template>
                        <template v-slot:[`item.isAccountDisabled`]="{ item }">
                            <v-simple-checkbox v-model="item.isAccountDisabled" dense disabled></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import api from '@/api'
export default {
    name: 'UserManager',
    data() {
        return {
            isLoading: false,
            registrationCode: '',
            checkbox: false,
            users: [],
            teams: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'firstName',
                },
                { text: 'Display Name', value: 'displayName' },
                { text: 'email', value: 'email' },
                { text: 'Status', value: 'status' },
                { text: 'Team', value: 'teamName' },
                { text: 'Role', value: 'roles' },
                { text: 'Last Login', value: 'lastLogin' },
            ],
            userEditing: null,
        }
    },
    mounted() {
        this.getTeams()
        this.getUsers()
    },
    methods: {
        getUsers() {
            this.isLoading = true
            api.get('user/getAllUsers')
                .then(res => {
                    res.map(x => {
                        x.teamName = this.getTeamNameById(x.defaultTeamId)
                        x.status = this.getUserStatus(x)
                        return x
                    })
                    this.users = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        getTeams() {
            this.isLoading = true
            api.getTeams()
                .then(res => {
                    this.teams = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        getTeamNameById(teamId) {
            if (!this.teams || this.teams.length === 0) return ''
            var team = this.teams.find(x => x.id === teamId)
            if (!team) return ''
            return team.name
        },
        getUserStatus(user) {
            if (user.isAccountDisabled) return 'Disabled'
            if (!user.emailConfirmed) return 'Unconfirmed'
            if (!user.roles || user.roles.length === 0) return 'Setup Required'
            if (!user.defaultTeamId) return 'Setup Required'
            return 'Active'
        },
        getRegistrationCode() {
            this.registrationCode = ''
            this.isLoading = true
            api.get('user/generateRegistrationCode')
                .then(res => {
                    this.registrationCode = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        copyLink() {
            var copyText = document.querySelector('#linkField')
            copyText.select()
            document.execCommand('copy')
            this.copyLink = ''
        },
    },
}
</script>
